import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* getLoyalty(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.LOYALTY.GET_LOYALTY, action.payload, true);
}

export function* loyaltyDetails(action: any): any {
    const loyaltyId = action.payload || "";
    yield call(sagaFunction, action, CallApi.GET, `${APIS.LOYALTY.LOYALTY_DETAILS}${loyaltyId}`, {}, true);
}

export function* addUpdateLoyalty(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOYALTY.ADD_UPDATE_LOYALTY, action.payload, true);
}

export function* deleteLoyalty(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.LOYALTY.DELETE_LOYALTY, action.payload, true);
}

export function* getAvgCustomerSpend(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, `${APIS.LOYALTY.GET_AVG_CUSTOMER_SPEND}`, action.payload, true);
}

export function* getLoyaltySales(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, `${APIS.LOYALTY.GET_LOYALTY_SALES}`, action.payload, true);
}

export function* getTopCustomers(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, `${APIS.LOYALTY.GET_TOP_CUSTOMERS}`, action.payload, true);
}

export function* getCustomerVisits(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, `${APIS.LOYALTY.GET_CUSTOMER_VISITS}`, action.payload, true);
}

export function* getRewardsData(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, `${APIS.LOYALTY.GET_REWARDS_DATA}`, action.payload, true);
}